const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoopColour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.5 180.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2,87.4c1.1,0,1.9-.9,1.9-1.9C173.1,38.4,134.6.6,87.3.6S1.4,38.5.4,85.5c0,1.1.8,1.9,2,1.9h169.9,0,0Z",
    style: {
      fill: "#20374c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2,87.4c1.1,0,1.9-.9,1.9-1.9C173.1,38.4,134.6.6,87.3.6S1.4,38.5.4,85.5c0,1.1.8,1.9,2,1.9h169.9,0,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2,87.4c1.1,0,1.9-.9,1.9-1.9C173.1,38.4,134.6.6,87.3.6S1.4,38.5.4,85.5c0,1.1.8,1.9,2,1.9h169.9,0,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2,87.4c1.1,0,1.9-.9,1.9-1.9C173.1,38.4,134.6.6,87.3.6S1.4,38.5.4,85.5c0,1.1.8,1.9,2,1.9h169.9,0,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2,87.4c1.1,0,1.9-.9,1.9-1.9C173.1,38.4,134.6.6,87.3.6S1.4,38.5.4,85.5c0,1.1.8,1.9,2,1.9h169.9,0,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2,87.4c1.1,0,1.9-.9,1.9-1.9C173.1,38.4,134.6.6,87.3.6S1.4,38.5.4,85.5c0,1.1.8,1.9,2,1.9h169.9,0,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,180.6c17.3,0,31.3-14,31.3-31.4s-14-31.3-31.3-31.3-31.3,14-31.3,31.3,14,31.4,31.3,31.4Z",
    style: {
      fill: "#9b9b96"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2,87.4c1.1,0,1.9-.9,1.9-1.9C173.1,38.4,134.6.6,87.3.6S1.4,38.5.4,85.5c0,1.1.8,1.9,2,1.9h169.9,0,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,180.6c17.3,0,31.3-14,31.3-31.4s-14-31.3-31.3-31.3-31.3,14-31.3,31.3,14,31.4,31.3,31.4Z",
    style: {
      fill: "#9b9b96"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.2,
    cy: 169.4,
    r: 4.8,
    style: {
      fill: "#fffaf5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2,87.4c1.1,0,1.9-.9,1.9-1.9C173.1,38.4,134.6.6,87.3.6S1.4,38.5.4,85.5c0,1.1.8,1.9,2,1.9h169.9,0,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,180.6c17.3,0,31.3-14,31.3-31.4s-14-31.3-31.3-31.3-31.3,14-31.3,31.3,14,31.4,31.3,31.4Z",
    style: {
      fill: "#9b9b96"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.2,
    cy: 169.4,
    r: 4.8,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9,87.4h1.4c24.9,0,45.1,20.2,45.1,45.2v15.7c0,1.1-.8,1.9-1.9,1.9H43.7c-1,0-1.9-.8-1.9-1.9v-15.7c0-24.9,20.3-45.2,45.1-45.2h0,0Z",
    style: {
      fill: "#143223"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.2,87.4c1.1,0,1.9-.9,1.9-1.9C173.1,38.4,134.6.6,87.3.6S1.4,38.5.4,85.5c0,1.1.8,1.9,2,1.9h169.9,0,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 22.2,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.7,
    cy: 50.5,
    r: 15.5,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,180.6c17.3,0,31.3-14,31.3-31.4s-14-31.3-31.3-31.3-31.3,14-31.3,31.3,14,31.4,31.3,31.4Z",
    style: {
      fill: "#9b9b96"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.2,
    cy: 169.4,
    r: 4.8,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9,87.4h1.4c24.9,0,45.1,20.2,45.1,45.2v15.7c0,1.1-.8,1.9-1.9,1.9H43.7c-1,0-1.9-.8-1.9-1.9v-15.7c0-24.9,20.3-45.2,45.1-45.2h0,0Z",
    style: {
      fill: "#143223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,25.2h43.4c4,0,7.3,3.2,7.3,7.3h0c0,4-3.2,7.3-7.3,7.3h-43.4c-4,0-7.3-3.2-7.3-7.3h0c0-4,3.2-7.3,7.3-7.3Z",
    style: {
      fill: "#20374c"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoopColour);
export default __webpack_public_path__ + "static/media/Boop-colour.32fa79587f5caa90ffda5d66a4937ab6.svg";
export { ForwardRef as ReactComponent };